import $ from 'jquery';

$(() => {
  const elements = $('.accordion li');

  function checkAccordeonCurrentHeight() {
    elements.each(function () {
      if ($(this).hasClass('current')) {
        const paneHeight = $(this).find('.pane').children().outerHeight();
        $(this).find('.pane').height(paneHeight);
      } else {
        $(this).find('.pane').height(0);
      }
    });
  }

  function calculateHeight(elem) {
    let computedHeight = 0;
    const newAddressWrapper = elem.closest('.option-wrapper');
    checkAccordeonCurrentHeight();

    if (newAddressWrapper.hasClass('active')) {
      $.each(newAddressWrapper.children(), function () {
        computedHeight += $(this).outerHeight(true);
      });

      $(elem).closest('.option-wrapper').height(computedHeight);
    } else {
      $(elem).closest('.option-wrapper').height($(elem).outerHeight() + 5);
    }
    checkAccordeonCurrentHeight();
  }

  function radioDefaultOption() {
    const deliveryExistingAddress = $('#checkout-existing-address-option');
    const deliveryNewAddress = $('#checkout-new-address-option');
    const billingSameAddress = $('#checkout-same-billing-option');
    const billingNewAddress = $('#checkout-new-billing-option');

    deliveryExistingAddress.prop('checked', true);
    deliveryNewAddress.prop('checked', false);

    deliveryExistingAddress.parent().addClass('active');
    deliveryNewAddress.parent().removeClass('active');

    billingSameAddress.prop('checked', true);
    billingNewAddress.prop('checked', false);

    billingSameAddress.parent().addClass('active');
    billingNewAddress.parent().removeClass('active');

    calculateHeight(deliveryNewAddress);
    calculateHeight(billingNewAddress);
  }

  function nextStep() { // eslint-disable-line no-unused-vars
    const currentAccordeonSection = $('.accordion .current');
    const animatedHeightElement = currentAccordeonSection.children('.pane');
    if (currentAccordeonSection.next('li').length) {
      if (animatedHeightElement.hasClass('no-height-animation')) {
        animatedHeightElement.removeClass('no-height-animation');
      }
      currentAccordeonSection.removeClass('current');
      currentAccordeonSection.addClass('completed');
      currentAccordeonSection.next('li').addClass('current');
    }
  }

  function clearBillingField(fieldset) {
    fieldset.find('input[type="text"]').val('');

    const $selectState = fieldset.find('#checkout-new-address-state-billing').selectize();
    const selectizeResetState = $selectState[0].selectize;
    selectizeResetState.setValue('0');

    const $selectCountry = fieldset.find('#checkout-new-address-country-billing').selectize();
    const selectizeResetCountry = $selectCountry[0].selectize;
    selectizeResetCountry.setValue('0');

    fieldset.find('.panel-section').removeClass('valid');
    fieldset.find('.panel-section').removeClass('invalid');
  }

  function clearDeliveryField(fieldset) {
    const fieldPanelSection = fieldset.find('.panel-section');
    fieldset.find('input[type="text"]').val('');

    const $selectState = fieldset.find('#checkout-new-address-state').selectize();
    const selectizeResetState = $selectState[0].selectize;
    selectizeResetState.setValue('0');

    const $selectCountry = fieldset.find('#checkout-new-address-country').selectize();
    const selectizeResetCountry = $selectCountry[0].selectize;
    selectizeResetCountry.setValue('0');

    fieldPanelSection.removeClass('valid');
    fieldPanelSection.removeClass('invalid');
  }

  function backStep() { // eslint-disable-line no-unused-vars
    const currentAccordionSection = $('.accordion .current');
    const previousAccordionSection = currentAccordionSection.prev('li');
    if (previousAccordionSection.length) {
      currentAccordionSection.removeClass('current');
      previousAccordionSection.addClass('current');
      previousAccordionSection.removeClass('completed');
    }
    if (previousAccordionSection.find('.delivery').length) {
      previousAccordionSection.find('.pane').removeClass('no-height-animation');
      radioDefaultOption();
      clearDeliveryField($('.delivery'));
      clearBillingField($('.billing'));
    }
  }

  function toggleActive(elem) {
    const radioButtonWrapper = elem.closest('.option-wrapper');
    $(radioButtonWrapper).toggleClass('active');
    $(radioButtonWrapper).siblings('.option-wrapper').toggleClass('active');
  }

  $('.delivery .radio-label').on('click', (e) => {
    if (!(e.target.closest('div.option-wrapper').classList.contains('active'))) {
      toggleActive(e.target);
      calculateHeight($("label[for = 'checkout-new-address-option']"));
    }
  });

  $('.billing .radio-label').on('click', (e) => {
    if (!(e.target.closest('div.option-wrapper').classList.contains('active'))) {
      toggleActive(e.target);
      calculateHeight($("label[for = 'checkout-new-billing-option']"));
    }
  });

  $('label[for="checkout-existing-address-option"]').on('click', function () {
    clearDeliveryField($(this).closest('fieldset'));
  });

  $('label[for="checkout-same-billing-option"]').on('click', function () {
    clearBillingField($(this).closest('fieldset'));
  });

  checkAccordeonCurrentHeight();

  $(window).on('resize', () => {
    calculateHeight($("label[for = 'checkout-new-address-option']"));
    calculateHeight($("label[for = 'checkout-new-billing-option']"));
  });

  // Please execute nextStep() and checkAccordeonCurrentHeight() clicking on NEXT button
  // Please execute backStep() and checkAccordeonCurrentHeight() clicking on BACK button

  $('.accordion .checkout-back-step').on('click', () => {
    backStep();
    checkAccordeonCurrentHeight();
  });
  $('.accordion .checkout-next-step').on('click', () => {
    nextStep();
    checkAccordeonCurrentHeight();
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/accordion.js
 **/